module.exports = __webpack_public_path__ + "static/img/ry_huli.cf59003e.png";